module.exports = __webpack_public_path__ + "static/media/rbtak.aa782191.gif";